import { render, staticRenderFns } from "./BenefitNotificationBox.vue?vue&type=template&id=4cc82b05&scoped=true&"
import script from "./BenefitNotificationBox.vue?vue&type=script&lang=js&"
export * from "./BenefitNotificationBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc82b05",
  null
  
)

export default component.exports